
export const clientDetails = {
    namespaced: true,
    state: {
        status: 'idle',
        clientDetails: null
    },
    mutations: {
        SET_CLIENT_DETAILS_STATUS(state, status) {
            state.status = status
        }
    },

    actions: {
        async saveClientDetails({ state, commit, dispatch }, payload) {
            try {
                commit('SET_CLIENT_DETAILS_STATUS', 'loading')
                await this.$api.put('/api/client-details', payload)
                commit('SET_CLIENT_DETAILS_STATUS', 'idle')
            } catch(err) {
                commit('SET_CLIENT_DETAILS_STATUS', 'error')
                if (err.response.data.data.errors.vat_id) {
                    dispatch('addNotification', {
                        type: 'danger',
                        content: 'Nieprawidłowy NIP'
                    }, { root: true })
                } else if (err.response.data.data.errors.postal_code) {
                    dispatch('addNotification', {
                        type: 'danger',
                        content: 'Nieprawidłowy kod pocztowy'
                    }, { root: true })
                } else {
                    dispatch('addNotification', {
                        type: 'danger',
                        content: 'Wystąpił bład'
                    }, { root: true })
                }
                throw err
            }
        }
    }
}
